import { Box, Stack } from "@mui/joy";
import Button from "@mui/joy/Button";
import { ProgramContentType } from "data/BlockComponent";
import { SingleSelectionType } from "data/CellComponent";
import * as _ from "lodash";
import { useState } from "react";

export default function ButtonGroupInput({
  defaultValue,
  index,
  options,
  optionKeys,
  setData,
  lineIndex,
  cellIndex,
  isCoach,
}: {
  defaultValue?: string;
  index: number;
  options: string[];
  optionKeys?: string[];
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  lineIndex: number;
  cellIndex: number;
  isCoach: boolean;
}) {
  const [selected, setSelected] = useState<string | undefined>(defaultValue);

  const handleChange = (
    selected?: string,
    optionIndex?: number,
    selectedTranslationKey?: string
  ) => {
    setData((data) => {
      if (data) {
        const originalCurrentContent = (data[index].lines[lineIndex][cellIndex]
          .content || {}) as SingleSelectionType;

        if (!_.isEqual(originalCurrentContent.value, selected)) {
          const data_temp = _.cloneDeep(data);

          if (selected) {
            const selectedOption = originalCurrentContent.options?.find(
              (element) =>
                selectedTranslationKey
                  ? element.translationKey === selectedTranslationKey
                  : element.text === selected
            );
            console.log(
              selected,
              originalCurrentContent.options,
              selectedOption
            );
            const showFromIndex = data_temp.findIndex(
              (element) =>
                element.blockId &&
                element.blockId === selectedOption?.showFromId
            );

            const hideFromIndex = data_temp.findIndex(
              (element) =>
                element.blockId &&
                element.blockId === selectedOption?.hideFromId
            );

            if (showFromIndex > -1) {
              data_temp.forEach((e, i) => {
                if (i > index && i < showFromIndex) {
                  data_temp[i].isHidden = true;
                }
                if (hideFromIndex > -1) {
                  if (i >= Math.min(showFromIndex, hideFromIndex)) {
                    if (
                      (showFromIndex < hideFromIndex && i >= hideFromIndex) ||
                      (showFromIndex > hideFromIndex && i < showFromIndex)
                    ) {
                      data_temp[i].isHidden = true;
                    } else {
                      data_temp[i].isHidden = false;
                    }
                  }
                }
              });
            }

            data_temp[index].nextBlockId =
              selectedOption?.showFromId || `buttongroup_option_${selected}`;
          } else {
            data_temp.forEach((e, i) => {
              if (i > index) {
                if (!isCoach) {
                  data_temp[i].isHidden = true;
                }
              }
            });
          }

          const currentContent =
            data_temp[index].lines[lineIndex][cellIndex].content || {};
          data_temp[index].lines[lineIndex][cellIndex].content = {
            ...currentContent,
            value: selected,
            selectedIndex: optionIndex,
            selectedTranslationKey: selectedTranslationKey,
          };

          return data_temp;
        }
        return data;
      }

      return data;
    });
  };
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      sx={{
        width: "100%",
        whiteSpace: "nowrap",
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      {options.map((option, optionIndex) => (
        <Box
          key={`buttongroup_option_${index}_${lineIndex}_${cellIndex}_${optionIndex}`}
          sx={{ flexGrow: 1 }}
        >
          <Button
            fullWidth
            variant={selected === option ? "solid" : "outlined"}
            color="primary"
            value={option}
            onClick={(e) => {
              const selectedText = (e?.target as HTMLElement)?.innerText;
              const selectedTranslationKey = optionKeys
                ? optionKeys[optionIndex]
                : undefined;
              if (selected !== selectedText) {
                setSelected(selectedText);
                handleChange(selectedText, optionIndex, selectedTranslationKey);
              } else {
                setSelected(undefined);
                handleChange(undefined, undefined, undefined);
              }
            }}
          >
            {option}
          </Button>
        </Box>
      ))}
    </Stack>
  );
}
